import {
  FormFieldWidget,
  ModelFieldType,
  SPI,
  ViewType,
  Widget,
  http,
  BaseActionWidget,
  DialogViewActionWidget,
  ActionType,
  ViewActionTarget,
  ActiveRecord,
  PopupManager,
  ModelCache,
  type IPopupInstance,
  type RuntimeAction,
  VueWidget,
  type RuntimeContext,
  ROOT_HANDLE,
  executeViewAction,
  RuntimeViewAction,
  DslDefinition,
  DslRender,
  DialogWidget,
  RuntimeServerAction,
  ServerActionWidget,
  SubmitValue,
  ActionContextType,
  ActiveRecords,
  SubmitRelationValue,
  ClickResult,
  BaseElementWidget,
  FormWidget,
  registerLayout,
  ActionWidget,
  DebugConfigureService,
  Dialog,
  MultiTabsManager,
  ViewActionCache
} from '@kunlun/dependencies';
import { cloneDeep } from 'lodash-es';
import { CallChaining, OioMessage, OioNotification } from '@kunlun/vue-ui-antd';
import dayjs from 'dayjs';
import { CascaderProps, Modal } from 'ant-design-vue';
import { addressFileURL } from '../../../../utils/config';
import { removeDecimalZero } from '../../../../utils/number';
import SendGoods from './SendGoods.vue';
import { mirrorConstructMutation, mirrorConstructQuery, queryAddressList, queryLogisticsProviderList, submitData as submitDataApi, tmsOrderConstruct } from './services';
import { queryLimitProvinceList } from '../../../../api';
import { useProductPackage } from '../../../../hooks';
import { setObjValue } from '../../../../utils/object';
import { exportExcelFile } from '../../../../utils/excel';
import { ref } from 'vue';

const addressData = ref();
const orderId = ref();

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form, ViewType.Detail],
    ttype: ModelFieldType.String,
    widget: 'SendGoods',
    multi: false
  })
)
export class FormStringSendGoodsFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(SendGoods);
    return this;
  }

  @Widget.Reactive()
  get rModel() {
    return this.model;
  }

  @Widget.Reactive()
  @Widget.Inject()
  protected mountedCallChaining: CallChaining | undefined;

  @Widget.Reactive()
  private get inventoryStatusEnum() {
    return Object.entries(this.INVENTORY_STATUS_ENUM_MAP).map(([key, val]) => {
      return {
        value: key,
        label: val
      };
    });
  }

  private INVENTORY_STATUS_ENUM_MAP = {
    ALL_SATISFIED: '全部满足',
    PARTIALLY_FULFIL: '部分满足',
    NOT_SATISFIED: '不满足'
  } as const;

  @Widget.Method()
  private formatInventoryStatus(s: string) {
    if (s) {
      return this.INVENTORY_STATUS_ENUM_MAP[s];
    }
    return this.INVENTORY_STATUS_ENUM_MAP.NOT_SATISFIED;
  }

  @Widget.Reactive()
  get modelStr() {
    return this.model.model;
  }

  @Widget.Reactive()
  errorArr: any[] = [];

  @Widget.Reactive()
  errorTableColums: any[] = [];

  @Widget.Reactive()
  public data: {
    mainData: Record<any, any>;
    searchKey: string;
    customerServiceDeliveryTime: string;
    remark: string;
    originRegionOptions: CascaderProps['options'];
    regionOptions: CascaderProps['options'];
    selectedRegion: string[];
    addressOptions: any[];
    logisticsProvider: Record<any, any>[];
    sellerRemark: string;
    buyerRemark: string;
  } = {
    mainData: {
      ariesIssuingMethodEnum: 'NOMAL',
      warehouseDeliveryTypeEnum: null,
      tmsDeliveryMethod: null,
      deliveryAddressTypeEnum: 'CONTRACT',
      deliveryAreaTypeEnum: null
    },
    searchKey: '',
    customerServiceDeliveryTime: '',
    remark: '',
    originRegionOptions: [],
    regionOptions: [],
    selectedRegion: [],
    addressOptions: [],
    logisticsProvider: [],
    sellerRemark: '',
    buyerRemark: ''
  };

  @Widget.Reactive()
  public dataLoading = false;

  @Widget.Reactive()
  public get modelActions() {
    return this.metadataRuntimeContext.model.modelActions;
  }

  /**
   * 整单取消的按钮
   */
  @Widget.Reactive()
  public get allCancelAction() {
    return this.modelActions.find((a) => a.label === '整单取消') as RuntimeViewAction;
  }

  /**
   * 部分取消的按钮
   */
  @Widget.Reactive()
  public get partCancelAction() {
    return this.modelActions.find((a) => a.label === '部分取消') as RuntimeViewAction;
  }

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }

  @Widget.Reactive()
  private mountedProcessSignal = false;

  @Widget.Method()
  public async mountedProcess() {
    await this.initData();
    this.mountedProcessSignal = true;

    Promise.all([this.getRegionList(), this.queryAddress(), this.queryLogisticsProvider()]);

    this.importModel = await ModelCache.get('deli.aries.seller.DeliAriesSellerCreateTmsOrderDetail');
  }

  @Widget.Method()
  setData(value, property?: string) {
    setObjValue(this.data, value, property);
  }

  @Widget.Method()
  private async initData() {
    this.dataLoading = true;
    try {
      const tradeOrderId = this.formData?.tradeOrderId ?? (this.rootData?.[0]?.currency as any)?.id;
      const realId = this.formData?.realId;
      if (!tradeOrderId && !realId) {
        throw new Error('订单ID为空');
      }
      const resData = (await tmsOrderConstruct(this.rModel, { tradeOrderId: tradeOrderId || realId })) ?? {};
      // 初始化数据时默认选中所有项
      resData.tmsOrderDetails?.forEach((item) => {
        item.isSelected = !!item.isSelected;
      });

      // 整散件
      if (!resData.warehouseDeliveryTypeEnum) {
        resData.warehouseDeliveryTypeEnum = 'PARTS_AND_ALL';
      }

      if (resData.deliveryAddress?.address) {
        this.data.selectedRegion = [resData.deliveryAddress.address.provinceCode, resData.deliveryAddress.address.cityCode, resData.deliveryAddress.address.districtCode];
        resData.deliveryAddress.address.fullAddress = [
          '中国',
          resData.deliveryAddress.address.provinceName,
          resData.deliveryAddress.address.cityName,
          resData.deliveryAddress.address.districtName,
          resData.deliveryAddress.detailAddress
        ].join('');
      } else {
        console.error('前端日志', '发货地址无返回值，tmsOrderConstruct 字段 deliveryAddress.address');
      }
      Object.assign(this.data.mainData, resData);
      resData.customerServiceDeliveryTime && (this.data.customerServiceDeliveryTime = resData.customerServiceDeliveryTime as string);
    } finally {
      this.dataLoading = false;
    }
  }

  @Widget.Reactive()
  public importModel: any;

  private async queryAddress() {
    const { buyerPartnerId } = this.data.mainData;
    if (!buyerPartnerId) {
      throw new Error('data error');
    }
    const resData = (await queryAddressList(this.rModel, { buyerPartnerId })) ?? {};
    this.data.addressOptions = (resData.content as any[]) ?? [];
  }

  private async queryLogisticsProvider() {
    const resData = (await queryLogisticsProviderList(this.rModel)) ?? {};
    this.data.logisticsProvider = (resData.content as any[]) ?? [];
  }

  /**
   * 整单取消
   */
  @Widget.Method()
  protected async onAllCancel() {
    if (this.allCancelAction) {
      executeViewAction({
        ...this.allCancelAction,
        context: {
          id: this.formData.tradeOrderId
        }
      });
    }
  }

  /**
   * 部分取消
   */
  @Widget.Method()
  protected async onPartCancel() {
    if (this.partCancelAction) {
      orderId.value = this.formData.tradeOrderId;

      const that = this;
      function partCancelCloseFn(manager: PopupManager, instance: IPopupInstance, action?: RuntimeServerAction) {
        if (action?.name === 'closeOrderPart' || action?.fun === 'closeOrderPart') {
          that.mountedProcess();
        }
        PopupManager.INSTANCE.clearOnClose(partCancelCloseFn);
      }

      PopupManager.INSTANCE.onClose(() => {});
      PopupManager.INSTANCE.onClose(partCancelCloseFn);

      executeViewAction({
        ...this.partCancelAction,
        context: {
          id: this.formData.tradeOrderId,
          orderId: this.formData.tradeOrderId
        }
      });
    }
  }

  @Widget.Method()
  private async mirrorConstruct(changeType: 'operateNum' | 'sellerDeliveryWarehouse', selectedWarehouse = false, updatePart = false, batchEditModalOperatorNum = null) {
    const data = cloneDeep(this.data.mainData);
    const ariesIssuingMethodOptions = data.ariesIssuingMethodOptions;
    delete data.ariesIssuingMethodOptions;

    data.customerServiceDeliveryTime = dayjs(this.data.customerServiceDeliveryTime).format('YYYY-MM-DD HH:mm:ss');
    data.selectedWarehouse = selectedWarehouse;

    let submitTmsOrderDetails = data.tmsOrderDetails;

    if (updatePart) {
      submitTmsOrderDetails = submitTmsOrderDetails.filter((i) => i.isPartSubmitRow);
    }
    submitTmsOrderDetails.forEach((item) => {
      item.isSelected = !!item.isSelected;
      if (changeType !== 'sellerDeliveryWarehouse') {
        item.tradeOrderOptions = null;
      }
      delete item._X_ROW_KEY;
      delete item.__draftId;
      delete item.isPartSubmitRow;
      delete item.itemKarNum;
    });
    const fnMap: Record<typeof changeType, typeof mirrorConstructQuery> = {
      operateNum: mirrorConstructMutation,
      sellerDeliveryWarehouse: mirrorConstructQuery
    } as const;
    //       isTransfer: mirrorConstructMutation,
    const fn = fnMap[changeType];

    const resData = await fn(this.rModel, { ...data, tmsOrderDetails: submitTmsOrderDetails });
    if (resData.deliveryAddress?.address) {
      resData.deliveryAddress.address.fullAddress = [
        '中国',
        resData.deliveryAddress.address.provinceName,
        resData.deliveryAddress.address.cityName,
        resData.deliveryAddress.address.districtName,
        resData.deliveryAddress.detailAddress
      ].join('');
    }
    resData.tmsOrderDetails?.forEach((item) => {
      item.isSelected = !!item.isSelected;
      if (batchEditModalOperatorNum) {
        item.operateNum = batchEditModalOperatorNum;
      }
      // item.isTransfer = !!batchEditIsTransfer
    });
    let mergeedTmsOrderDetails = resData.tmsOrderDetails;
    // 部分更新
    if (updatePart) {
      // 根据 tradeOrderDetailId 匹配明细行更新行数据
      const compareKey = 'tradeOrderDetailId';
      resData.tmsOrderDetails?.forEach((i) => {
        data.tmsOrderDetails.forEach((j) => {
          if (i[compareKey] === j[compareKey]) {
            Object.assign(j, { ...i });
            for (let k in j) {
              if (i[k] == undefined) {
                delete j[k];
              }
            }
          }
        });
      });
      mergeedTmsOrderDetails = data.tmsOrderDetails;
    }
    Object.assign(this.data.mainData, {
      ...resData,
      tmsOrderDetails: mergeedTmsOrderDetails,
      warehouseDeliveryTypeEnum: data.warehouseDeliveryTypeEnum,
      ariesIssuingMethodOptions
    });
    resData.customerServiceDeliveryTime && (this.data.customerServiceDeliveryTime = resData.customerServiceDeliveryTime as string);
  }

  private async getRegionList() {
    let str;

    if (addressData.value) {
      str = addressData.value;
    } else {
      const res = await fetch(addressFileURL, { method: 'GET' });
      const data = await res.text();

      str = data.replace('regionTreeResolve(', '').replace(/\)/g, '');
      addressData.value = str;
    }

    const province = JSON.parse(str)[0]?.children ?? [];
    // 下钻，第四级 镇/乡/街道 不需要
    province.forEach((i) => {
      i?.children?.forEach((j) => {
        j?.children?.forEach((k) => {
          if (k.children) {
            k.children = [];
          }
        });
      });
    });
    this.data.originRegionOptions = province;
    this.data.regionOptions = province;
    this.limitProvince();
  }

  @Widget.Method()
  private async submitData(forceDelivery = false, tableData) {
    const formattedDeliveryTime = dayjs(this.data.customerServiceDeliveryTime).format('YYYY-MM-DD HH:mm:ss');

    const data: Record<any, any> = {
      ...cloneDeep(this.data.mainData),
      customerServiceDeliveryTime: formattedDeliveryTime,
      remark: this.data.remark
    };

    const tmsOrderDetails = tableData || data.tmsOrderDetails || [];

    data.tmsOrderDetails = tmsOrderDetails.filter((item) => item.isSelected);
    data.tmsOrderDetails?.forEach((item) => {
      item.isSelected = !!item.isSelected;
      item.tradeOrderOptions = null;
      delete item._X_ROW_KEY;
      delete item.__draftId;
      delete item.isAbovePlanProductNum;
      delete item.itemKarNum;
    });
    // 是否强制发货
    data.forceDelivery = forceDelivery;

    delete data.ariesIssuingMethodOptions;
    const resData = await submitDataApi(this.rModel, data);
    return resData ?? {};
  }

  @Widget.Method()
  public exportFile(dataSource: any[]) {
    const { generateConvertRelationStr } = useProductPackage();
    const content = dataSource.map((item) => ({
      ERP商品编码: item.itemOutCode,
      商品名称: item.itemName,
      物料组: item.materialGroupName,
      BG分类: item.productBelong,
      结算扣率: removeDecimalZero(item.settlementDeductionRate),
      结算单价: removeDecimalZero(item.settlementPrice),
      可用库存: item.availableNum,
      库存满足情况: this.formatInventoryStatus(item.deliAriesInventoryStatusEnum),
      已发数量: item.deliveredNum,
      未发数量: item.undeliveredNum,
      确认数量: item.operateNum,
      换算关系: generateConvertRelationStr(item.itemSpecifications),
      发货仓库: item.sellerDeliveryWarehouse?.name
    }));
    exportExcelFile(content, { filename: `发货单${Date.now()}.xlsx` });
  }

  async limitProvince() {
    // 【代发方式=总部直发*】【本次发货范围=全国】【配送至=其他地址】，可录入全国地址
    // 或者【配送至=合同地址】，则不限制地址
    const ariesIssuingMethodEnum = this.data.mainData.ariesIssuingMethodEnum as string;
    const noLimit =
      (['MASTER_EXPRESS', 'MASTER_CONSIGNED'].includes(ariesIssuingMethodEnum) &&
        this.data.mainData.deliveryAreaTypeEnum === 'ALL' &&
        this.data.mainData.deliveryAddressTypeEnum === 'OTHER') ||
      this.data.mainData.deliveryAddressTypeEnum === 'CONTRACT';
    if (noLimit) {
      this.data.regionOptions = cloneDeep(this.data.originRegionOptions || []);
      return;
    }

    const buyerPartnerId = this.formData.buyerPartnerId || this.data.mainData.buyerPartnerId;
    const sellerPartnerId = this.formData.sellerPartnerId || this.data.mainData.sellerPartnerId;

    if (!ariesIssuingMethodEnum || !buyerPartnerId || !sellerPartnerId) {
      return;
    }

    const codes = await queryLimitProvinceList(this.rModel, {
      buyerPartnerId,
      sellerPartnerId,
      ariesIssuingMethodEnum: this.data.mainData.ariesIssuingMethodEnum
    });
    if (!codes.length) {
      return;
    }
    const interval = setInterval(async () => {
      if (this.data.originRegionOptions && this.data?.originRegionOptions?.length > 0) {
        clearInterval(interval);
        const arr = cloneDeep(this.data.originRegionOptions);
        this.data.regionOptions = arr.filter((j) => codes.map((i) => i.code).includes(j.code));
        // 当前值不存在于选项时，清除
        if (this.data.selectedRegion[0] && !this.data.regionOptions.some((item) => item.code === this.data.selectedRegion[0])) {
          this.data.selectedRegion = [];
        }
      }
    }, 100);
  }

  @Widget.Watch('formData.buyerPartnerId', { immediate: true })
  private watchBuyerPartnerId(val: string) {
    if (val) {
      this.limitProvince();
    }
  }

  @Widget.Watch('data.mainData.ariesIssuingMethodEnum')
  private watchAriesIssuingMethodEnum(val: string) {
    if (val) {
      this.limitProvince();
    }
  }

  @Widget.Watch('data.mainData.deliveryAreaTypeEnum')
  private watchDeliveryAreaTypeEnum(val: string) {
    if (val) {
      this.limitProvince();
    }
  }

  @Widget.Watch('data.mainData.deliveryAddressTypeEnum')
  private watchDeliveryAddressTypeEnum(val: string) {
    if (val) {
      this.limitProvince();
    }
  }

  @Widget.Method()
  private openPlanDetail(id: string) {
    const modelActions = this.metadataRuntimeContext.model.modelActions;
    const viewAction = modelActions.find((a) => a.name === 'uiView08e4bb82eaba4f048ef994a864d6316d') as RuntimeViewAction;
    if (!viewAction) {
      OioNotification.error('错误', '未找到视图配置');
    }
    executeViewAction(viewAction, undefined, undefined, {
      id
    });
  }
}

@SPI.ClassFactory(
  BaseActionWidget.Token({
    actionType: [ActionType.View],
    target: [ViewActionTarget.Dialog],
    viewName: '品牌工作台销售订单列表_TABLE_0000000000111524'
  })
)
export class SendGoodsBtn extends DialogViewActionWidget {
  protected createPopupWidget(data: ActiveRecord[]): void {
    super.createPopupWidget(data);

    const innerDisposeFn = (manager: PopupManager, instance: IPopupInstance, action?: RuntimeAction) => {
      if (instance.key === this.dialog?.getHandle()) {
        // 关闭后的业务逻辑
        this.refreshCallChaining?.syncCall(true);
      }
      PopupManager.INSTANCE.clearOnClose(innerDisposeFn);
    };

    PopupManager.INSTANCE.onClose(innerDisposeFn);
  }

  protected executeRefreshRoot() {
    const targetRuntimeContext = this.findRefreshRootRuntimeContext();
    if (targetRuntimeContext) {
      const targetWidget = (Widget.select(targetRuntimeContext.handle) as VueWidget).getOperator<VueWidget & { refreshCallChaining?: CallChaining }>();
      if (targetWidget) {
        targetWidget.refreshCallChaining?.syncCall();
      }
    }
  }

  protected findRefreshRootRuntimeContext(): RuntimeContext | undefined {
    let targetRuntimeContext: RuntimeContext | undefined = this.rootRuntimeContext;
    while (targetRuntimeContext) {
      const parentRuntimeContext = targetRuntimeContext.parentContext;
      const nextFieldRuntimeContext = parentRuntimeContext?.parentContext;

      if (!nextFieldRuntimeContext || nextFieldRuntimeContext.handle === ROOT_HANDLE) {
        targetRuntimeContext = parentRuntimeContext;
        break;
      }

      if (!parentRuntimeContext || parentRuntimeContext.handle === ROOT_HANDLE) {
        break;
      }

      if (parentRuntimeContext.field) {
        targetRuntimeContext = parentRuntimeContext;
        continue;
      }

      if (nextFieldRuntimeContext.field) {
        targetRuntimeContext = nextFieldRuntimeContext;
      } else {
        targetRuntimeContext = parentRuntimeContext;
        break;
      }
    }
    return targetRuntimeContext;
  }
}

let currentPopup: any = undefined;
const orderIds: { id: string } = { id: '' };
@SPI.ClassFactory(
  BaseActionWidget.Token({
    actionType: [ActionType.View],
    target: [ViewActionTarget.Dialog],
    model: 'deli.aries.seller.DeliAriesSellerCreateTmsOrder',
    name: ['uiViewf1b2c466a4b8426eb6335ed98b42ae2b', 'uiView8b4ade20163e4aae898387cf69c2077f']
  })
)
export class openCancelPopup extends DialogViewActionWidget {
  public initialize(props) {
    super.initialize(props);
    return this;
  }
  protected createPopupWidget(data: ActiveRecord[]): void {
    if (data.length === 1) {
      orderIds.id = data[0].tradeOrderId as string;
      currentPopup = PopupManager;
    }
    super.createPopupWidget(data);
  }
}

@SPI.ClassFactory(
  BaseActionWidget.Token({
    actionType: ActionType.Server,
    widget: 'ServerAction',
    model: 'deli.aries.seller.deliAriesOrderAllCancelParam',
    name: 'uiServer29c735ddf97e46ce8f2ef071640b407f'
  })
)
export class cancelOrderBtn extends ServerActionWidget {
  protected async submit(action: RuntimeServerAction): Promise<SubmitValue> {
    let records: ActiveRecords | undefined;
    let relationRecords: SubmitRelationValue[] | undefined;
    if (!this.inline && this.submitCallChaining) {
      const callResult = await this.submitCallChaining?.syncCall();
      if (callResult != null) {
        records = callResult.records;
        relationRecords = callResult.relationRecords;
      }
    }
    if (records == null) {
      records = this.activeRecords || [];
    }
    if (action.contextType === ActionContextType.Batch || action.contextType === ActionContextType.SingleAndBatch) {
      // do nothing.
    } else if (action.contextType === ActionContextType.Single) {
      if (Array.isArray(records)) {
        [records] = records;
      }
    } else {
      const ttype = action.functionDefinition?.argumentList?.[0]?.ttype;
      if (ttype && [ModelFieldType.ManyToOne, ModelFieldType.OneToOne].includes(ttype as ModelFieldType)) {
        if (Array.isArray(records)) {
          [records] = records;
        }
      }
    }
    if (!records) {
      if (action.contextType !== ActionContextType.ContextFree) {
        const name = this.action?.displayName || this.action?.label;
        throw new Error(`${name} action not params`);
      }
      records = {};
    }
    // 处理参数 将订单编号传入
    if (orderIds.id) {
      //@ts-ignore
      records.orderIds = [orderIds.id];
    }
    return new SubmitValue(records, relationRecords);
  }

  protected async clickActionAfter(result: ClickResult) {
    Dialog.disposeAll();
    const key = MultiTabsManager.INSTANCE.getActiveTab()?.key;
    MultiTabsManager.INSTANCE.refresh(key!);
  }
}

@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Form,
    widget: 'PartCancelFormWidget'
  })
)
export class PartCancelFormWidget extends FormWidget {
  protected async mountedProcess() {
    let dataSource: ActiveRecords | undefined = this.dataSource;
    this.isDataSourceProvider = true;
    dataSource = await this.fetchData();

    if (dataSource && orderId.value) {
      dataSource.orderId = orderId.value;
      orderId.value = '';
    }

    this.reloadDataSource(dataSource);
    this.reloadActiveRecords(dataSource);

    this.repairViewMode();
  }
}

registerLayout(
  `<view type="FORM">
    <element widget="actionBar" slot="actionBar" slotSupport="action">
        <xslot name="actions" slotSupport="action" />
    </element>
    <element widget="PartCancelFormWidget" slot="form">
        <xslot name="fields" slotSupport="pack,field" />
    </element>
</view>`,
  {
    model: 'deli.aries.seller.deliAriesOrderPartCancelParam',
    viewType: ViewType.Form,
    moduleName: 'deliAriesCoreSeller'
  }
);

/**
 * 部分取消
 */

@SPI.ClassFactory(
  ActionWidget.Token({
    actionType: [ActionType.View],
    target: [ViewActionTarget.Dialog],
    // 模型编码
    model: 'deli.aries.seller.DeliAriesSellerCreateTmsOrder',
    // 动作名称
    name: 'uiViewf5269ece57ba49f79e561774c0026aa4'
  })
)
@SPI.ClassFactory(
  BaseActionWidget.Token({
    actionType: [ActionType.View],
    target: [ViewActionTarget.Dialog],
    model: 'deli.aries.seller.DeliAriesSellerCreateTmsOrder',
    name: ['uiView979cefbd6b484386a3837706ec213af2']
  })
)
export class openPartCancelPopup extends DialogViewActionWidget {
  public initialize(props) {
    super.initialize(props);
    return this;
  }

  protected async clickAction(...args: unknown[]): Promise<ClickResult> {
    if (this.activeRecords?.length) {
      this.activeRecords![0].id = this.activeRecords![0].tradeOrderId;
    }
    await super.clickAction();
    return true;
  }
}

@SPI.ClassFactory(
  BaseActionWidget.Token({
    actionType: ActionType.Server,
    widget: 'ServerAction',
    model: 'deli.aries.seller.deliAriesOrderPartCancelParam',
    name: 'uiServer843f5ed9ebab459ab63ba0a9a07dc7a8'
  })
)
export class partCancelSubmit extends ServerActionWidget {
  public initialize(props) {
    super.initialize(props);
    return this;
  }

  protected async clickActionAfter(result: ClickResult) {
    Dialog.disposeAll();
    this.reloadDataSource(result as any);
  }
}
